export { default } from './LazyVideo';
